var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBlk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.604,
    height: 16.604,
    viewBox: "0 0 16.604 16.604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M16.6,15.868l-5.173-5.173A6.5,6.5,0,0,0,1.9,1.875,6.5,6.5,0,0,0,10.724,11.4L15.9,16.576Zm-10.1-3.9a5.5,5.5,0,1,1,5.5-5.5A5.506,5.506,0,0,1,6.5,11.972Z",
    transform: "translate(0 0.028)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlk);
export default __webpack_public_path__ + "static/media/search-blk.504183aab6688252c800a1b8ed074cf4.svg";
export { ForwardRef as ReactComponent };